import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "../SectionHeading";
import { StaggerGroup, StaggerItem } from "../Reveal";
import { WHY_CHOOSE } from "../../data/site";

export const WhyChoose = () => {
  return (
    <section data-testid="why-section" className="relative py-24 md:py-32 bg-navy overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-brand-orange/10 blur-[160px]" />
      <div className="container-x relative">
        <SectionHeading
          overline="Why Choose ATS IT Solutions?"
          title="A partner built for reliability"
          subtitle="Four reasons serious technology decision-makers choose ATS over generic vendors."
        />

        <StaggerGroup className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {WHY_CHOOSE.map((w, i) => {
            const Icon = w.icon;
            return (
              <StaggerItem key={w.title}>
                <motion.div
                  whileHover={{ y: -6 }}
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  className="group relative glass rounded-3xl p-8 md:p-10 h-full overflow-hidden card-glow"
                >
                  <span className="absolute top-6 right-8 font-head text-7xl font-bold text-white/5 select-none">
                    0{i + 1}
                  </span>
                  <div className="w-14 h-14 rounded-2xl bg-white/5 grid place-items-center mb-6 group-hover:bg-brand-orange transition-colors duration-300">
                    <Icon size={26} className="text-brand-orange group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="font-head text-xl md:text-2xl font-semibold text-white mb-3">{w.title}</h3>
                  <p className="text-slate-400 leading-relaxed">{w.desc}</p>
                </motion.div>
              </StaggerItem>
            );
          })}
        </StaggerGroup>
      </div>
    </section>
  );
};

export default WhyChoose;
